import React from 'react'
import Bredcrum from '../../common/Bredcrum'

const CookiePolicy = () => {
    return (
        <>
            <Bredcrum
                heading={'Cookie Policy'}
                path={[
                    { name: 'Cookie Policy', path: 'cookie-policy' },
                ]}
            />

            <div className='my-5 pb-md-5 common-list-container'>
                <div className='auto-container p-md-5 p-4 pb-4' style={{ backgroundColor: '#f2f2f2' }}>
                    <div className="row">
                        <div className="sec-title mb-0">
                            <div className="card-body table-responsive">
                                <h5 className='mb-3'>COOKIE POLICY</h5>
                                <p>
                                    This Cookie Policy explains how Precision Driving School Limited t/a Precision
                                    Driving School ("we", "us", or "our") uses cookies and similar technologies
                                    when you visit our website at www.precisiondriving.uk ("Our Site"). It explains
                                    what these technologies are and why we use them, as well as your rights to
                                    control our use of them.
                                </p>
                                <p>
                                    This Cookie Policy should be read alongside our{' '}
                                    <a href='/privacy-policy' className='text-green'>Privacy Policy</a>,
                                    which sets out how and why we collect, store, use, and share personal data.
                                </p>

                                <ol className="mt-5 ps-0" start={1} style={{ listStyle: 'inside' }}>
                                    <li className='mb-5'>
                                        <h5 className='mb-3 fw-semibold'>1. What Are Cookies?</h5>
                                        <div className='ms-4'>
                                            <p>
                                                Cookies are small text files that are placed on your computer or mobile
                                                device when you visit a website. They are widely used to make websites
                                                work, or to work more efficiently, as well as to provide information to
                                                the owners of the site.
                                            </p>
                                            <p>
                                                Cookies allow a website to recognise your device and remember information
                                                about your visit, such as your preferred settings. This can make your next
                                                visit easier and the site more useful to you.
                                            </p>
                                        </div>
                                    </li>

                                    <li className='mb-5'>
                                        <h5 className='mb-3 fw-semibold'>2. How We Use Cookies</h5>
                                        <div className='ms-4'>
                                            <p>
                                                Our Site uses both first-party cookies (set directly by us) and
                                                third-party cookies (set by external services). We use cookies to:
                                            </p>
                                            <ul className='ms-3' style={{ listStyle: 'disc' }}>
                                                <li className='mb-2'>Ensure the security and proper functioning of Our Site</li>
                                                <li className='mb-2'>Remember your preferences and settings</li>
                                                <li className='mb-2'>Understand how visitors use Our Site so we can improve it</li>
                                                <li className='mb-2'>Deliver relevant advertising (where applicable)</li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li className='mb-5'>
                                        <h5 className='mb-3 fw-semibold'>3. Types of Cookies We Use</h5>
                                        <div className='ms-4'>
                                            <p>The cookies on Our Site fall into two categories:</p>

                                            <h6 className='mt-3 mb-2 fw-semibold'>Strictly Necessary Cookies</h6>
                                            <p>
                                                These cookies are essential for Our Site to function correctly. They
                                                enable core features such as security and session management. You cannot
                                                opt out of these cookies as the website cannot function properly without
                                                them.
                                            </p>

                                            <h6 className='mt-3 mb-2 fw-semibold'>Non-Essential Cookies</h6>
                                            <p>
                                                These cookies are not strictly required for the site to work but help us
                                                improve your experience and analyse how the site is used. You may decline
                                                these cookies via your browser settings.
                                            </p>
                                        </div>
                                    </li>

                                    <li className='mb-5'>
                                        <h5 className='mb-3 fw-semibold'>4. Cookies We Use</h5>
                                        <div className='ms-4'>
                                            <p>The following table lists the cookies used on Our Site:</p>
                                            <div className='table-responsive'>
                                                <table className="table table-bordered mt-4 policy-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Cookie Name</th>
                                                            <th>Provider</th>
                                                            <th>Purpose</th>
                                                            <th>Strictly Necessary</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>XSRF-TOKEN</td>
                                                            <td>Precision Driving School</td>
                                                            <td>
                                                                Ensures visitor browsing security by preventing cross-site
                                                                request forgery. This cookie is essential for the security of
                                                                the website and visitor.
                                                            </td>
                                                            <td>Yes</td>
                                                        </tr>
                                                        <tr>
                                                            <td>__zlcmid</td>
                                                            <td>Precision Driving School</td>
                                                            <td>Preserves users' states across page requests.</td>
                                                            <td>Yes</td>
                                                        </tr>
                                                        <tr>
                                                            <td>_ga</td>
                                                            <td>Google Analytics</td>
                                                            <td>
                                                                Registers a unique ID that is used to generate statistical
                                                                data on how the visitor uses the website.
                                                            </td>
                                                            <td>No</td>
                                                        </tr>
                                                        <tr>
                                                            <td>_gid</td>
                                                            <td>Google Analytics</td>
                                                            <td>
                                                                Registers a unique ID that is used to generate statistical
                                                                data on how the visitor uses the website.
                                                            </td>
                                                            <td>No</td>
                                                        </tr>
                                                        <tr>
                                                            <td>_gat</td>
                                                            <td>Google Analytics</td>
                                                            <td>Used by Google Analytics to throttle the request rate.</td>
                                                            <td>No</td>
                                                        </tr>
                                                        <tr>
                                                            <td>_dc_gtm_UA-#</td>
                                                            <td>Google Tag Manager</td>
                                                            <td>
                                                                Used by Google Tag Manager to control the loading of a
                                                                Google Analytics script tag.
                                                            </td>
                                                            <td>No</td>
                                                        </tr>
                                                        <tr>
                                                            <td>_gcl_au</td>
                                                            <td>Google AdSense</td>
                                                            <td>
                                                                Used by Google AdSense for experimenting with advertisement
                                                                efficiency across websites using their services.
                                                            </td>
                                                            <td>No</td>
                                                        </tr>
                                                        <tr>
                                                            <td>session</td>
                                                            <td>Precision Driving School</td>
                                                            <td>Maintains your session while using Our Site.</td>
                                                            <td>No</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </li>

                                    <li className='mb-5'>
                                        <h5 className='mb-3 fw-semibold'>5. How to Control Cookies</h5>
                                        <div className='ms-4'>
                                            <p>
                                                You can control and manage cookies in a number of ways. Please note
                                                that removing or blocking certain cookies may impact your experience
                                                on Our Site and some features may not work as intended.
                                            </p>

                                            <h6 className='mt-3 mb-2 fw-semibold'>Browser Settings</h6>
                                            <p>
                                                Most internet browsers allow you to manage your cookie preferences.
                                                You can set your browser to refuse or delete certain types of cookies.
                                                For more information, visit the help section of your browser:
                                            </p>
                                            <ul className='ms-3' style={{ listStyle: 'disc' }}>
                                                <li className='mb-2'>
                                                    <strong>Google Chrome:</strong> Settings &gt; Privacy and Security &gt; Cookies and other site data
                                                </li>
                                                <li className='mb-2'>
                                                    <strong>Mozilla Firefox:</strong> Options &gt; Privacy &amp; Security &gt; Cookies and Site Data
                                                </li>
                                                <li className='mb-2'>
                                                    <strong>Microsoft Edge:</strong> Settings &gt; Cookies and site permissions &gt; Cookies and site data
                                                </li>
                                                <li className='mb-2'>
                                                    <strong>Safari:</strong> Preferences &gt; Privacy &gt; Manage Website Data
                                                </li>
                                            </ul>

                                            <h6 className='mt-3 mb-2 fw-semibold'>Opting Out of Google Analytics</h6>
                                            <p>
                                                You can opt out of Google Analytics tracking by installing the{' '}
                                                <a
                                                    href='https://tools.google.com/dlpage/gaoptout'
                                                    target='_blank'
                                                    rel='noreferrer'
                                                    className='text-green'
                                                >
                                                    Google Analytics Opt-out Browser Add-on
                                                </a>.
                                            </p>
                                        </div>
                                    </li>

                                    <li className='mb-5'>
                                        <h5 className='mb-3 fw-semibold'>6. Third-Party Cookies</h5>
                                        <div className='ms-4'>
                                            <p>
                                                Some cookies on Our Site are set by third-party services such as Google
                                                Analytics and Google AdSense. These third parties have their own privacy
                                                policies which govern how they use cookie data. We recommend you review
                                                these policies:
                                            </p>
                                            <ul className='ms-3' style={{ listStyle: 'disc' }}>
                                                <li className='mb-2'>
                                                    <a href='https://policies.google.com/privacy' target='_blank' rel='noreferrer' className='text-green'>
                                                        Google Privacy Policy
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li className='mb-5'>
                                        <h5 className='mb-3 fw-semibold'>7. Changes to This Cookie Policy</h5>
                                        <div className='ms-4'>
                                            <p>
                                                We may update this Cookie Policy from time to time to reflect changes in
                                                technology, legislation, or our data practices. Any changes will be
                                                posted on this page with an updated effective date. We encourage you to
                                                review this policy periodically.
                                            </p>
                                        </div>
                                    </li>

                                    <li className='mb-5'>
                                        <h5 className='mb-3 fw-semibold'>8. Contact Us</h5>
                                        <div className='ms-4'>
                                            <p>
                                                If you have any questions about our use of cookies or this Cookie
                                                Policy, please contact us:
                                            </p>
                                            <p>
                                                <strong>Precision Driving School Limited</strong><br />
                                                4 Rivers Street, Leicester, England, LE3 5RX<br />
                                                Email: <a href='mailto:info@precisiondriving.uk' className='text-green'>info@precisiondriving.uk</a><br />
                                                Telephone: 0116 210 2688 / +44 7380 851496
                                            </p>
                                        </div>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CookiePolicy
